import Script from 'next/script'

/**
 * Cookie 插件
 */
const ConsentManager = () => {
  if (!process.env.NEXT_PUBLIC_CMP_ID) {
    return null
  }

  return (
    <Script
      id="consent-manager"
      src="https://cdn.consentmanager.net/delivery/js/semiautomatic.min.js"
      data-cmp-ab="1"
      data-cmp-cdid={process.env.NEXT_PUBLIC_CMP_ID}
      data-cmp-host="c.delivery.consentmanager.net"
      data-cmp-cdn="cdn.consentmanager.net"
      data-cmp-codesrc="0"
      strategy="afterInteractive"
    />
  )
}

export default ConsentManager
